import { useState } from 'react';
import { fetchPurchaseOrderHistory } from '../../services/purchaseOrderService';

function usePurchaseOrderHistory() {
  const [historyPurchaseOrder, setHistoryPurchaseOrder] = useState(null);
  const [historyLogs, setHistoryLogs] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [historyError, setHistoryError] = useState('');

  async function openHistoryModal(purchaseOrder) {
    setHistoryPurchaseOrder(purchaseOrder);
    setIsHistoryLoading(true);
    setHistoryError('');

    try {
      const response = await fetchPurchaseOrderHistory(purchaseOrder.id);
      setHistoryLogs(response);
    } catch (error) {
      setHistoryError(error.message);
    } finally {
      setIsHistoryLoading(false);
    }
  }

  function closeHistoryModal() {
    setHistoryPurchaseOrder(null);
    setHistoryLogs([]);
    setHistoryError('');
  }

  return {
    historyPurchaseOrder,
    historyLogs,
    isHistoryLoading,
    historyError,
    openHistoryModal,
    closeHistoryModal,
  };
}

export default usePurchaseOrderHistory;
